/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      this.addEventListener('change', this.handleVariantChange.bind(this));
     try {
      this.mergeProductDescription()
     } catch (error) {
      console.log(error)
     }
      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        this.updateAvailability();
        this.updateAddToCartButton();
      });
    }



    mergeProductDescription() {
      const mergeProduct = document.querySelector('[data-merge-product]');
      const firstDes = document.querySelector('.shopify-section.section-product-description') || document.querySelector('.shopify-section.rg-pdp')
      const mergeSkus = JSON.parse(mergeProduct.dataset.mergeProduct)
      this.mergeSkus = mergeSkus
      this.firstDes = firstDes
      if (!firstDes || mergeSkus.length === 0 || !mergeProduct) return 
      for(let i = 0; i < mergeSkus.length; i++) {
        const el = document.createElement('section')
        el.className = 'merge-product-section rg-hide rg-loading'
        el.style.minHeight = '100vh'
        el.innerHTML = '<span style="display: block; text-align: center; padding: 50px; color: #666;">Loading...</span>'
        el.dataset.mergeSku = mergeSkus[i].sku
        el.dataset.url = mergeSkus[i].product_url
        firstDes.insertAdjacentElement('afterend', el)
      }
      this.updateMergeProductDescription(this.variant.sku)
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(evt);

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }

     try {
      this.updateMergeProductDescription(this.variant.sku)
     } catch (error) {
      console.log(error)
     }
    }

    updateMergeProductDescription(sku) {
      console.log({sku})
      const _data = this.mergeSkus?.find(item => item.sku === sku)
      const el = document.querySelector(`.merge-product-section[data-merge-sku="${sku}"]`)

      if (!el || !_data) {
        document.querySelectorAll('.merge-product-section').forEach(item => {
          item.classList.add('rg-hide')
        })
        this.firstDes?.classList.remove('rg-hide')
        return
      }


      if (el.classList.contains('rg-loading')) {
        const url = el.dataset.url;
        if (url) {
          // 发送请求获取页面内容
          fetch(url)
            .then(response => response.text())
            .then(html => {
              // 解析HTML
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              // 创建CSS样式
              const style = doc.createElement('style');
              style.textContent = `
                body > *:not(#main-content) {
                  // display: none !important;
                  height: 0 !important;
                  opacity: 0 !important;
                  overflow: hidden !important;
                }
                #main-content > *:not(.shopify-section.section-product-description.merge-product-section):not(.shopify-section.rg-pdp) {
                  // display: none !important;
                  height: 0 !important;
                  opacity: 0 !important;
                  padding: 0 !important;
                  margin: 0 !important;
                  overflow: hidden !important;
                }
                  .product-tab,.tabs-nav {
                    top: 0 !important;
                  }
              `;
              
              // 将CSS插入到head中
              doc.head.appendChild(style);

              const desContentLineNodes = doc.querySelectorAll('[data-des-content-line]');
              if (desContentLineNodes.length > 1) {
                const forceVisible = (node) => {
                  if (!node) return;
                  node.removeAttribute?.('hidden');
                  node.classList?.remove('hidden', 'visually-hidden', 'rg-hide');
                  if (node.style) {
                    node.style.setProperty('display', 'block', 'important');
                    node.style.setProperty('visibility', 'visible', 'important');
                    node.style.setProperty('opacity', '1', 'important');
                    node.style.setProperty('height', 'auto', 'important');
                    node.style.setProperty('overflow', 'visible', 'important');
                    node.style.setProperty('padding', '', 'important');
                    node.style.setProperty('margin', '', 'important');
                  }
                };

                const revealBetweenParents = (nodeA, nodeB) => {
                  const parentA = nodeA?.parentElement;
                  const parentB = nodeB?.parentElement;
                  if (!parentA || !parentB) return;
                  if (parentA.parentElement !== parentB.parentElement) return;

                  let start = parentA;
                  let end = parentB;
                  const position = parentA.compareDocumentPosition(parentB);
                  if (position & Node.DOCUMENT_POSITION_PRECEDING) {
                    start = parentB;
                    end = parentA;
                  }

                  forceVisible(start);
                  forceVisible(end);

                  let current = start.nextElementSibling;
                  while (current && current !== end) {
                    if (current.matches && current.matches('div, section')) {
                      forceVisible(current);
                    }
                    current = current.nextElementSibling;
                  }
                };

                revealBetweenParents(desContentLineNodes[0], desContentLineNodes[1]);
              }
              
              // 获取处理后的HTML
              const processedHtml = doc.documentElement.outerHTML;
              
              // 创建iframe元素
              const iframe = document.createElement('iframe');
              iframe.style.width = '100%';
              iframe.style.border = 'none';
              iframe.style.overflow = 'hidden';
              iframe.style.height = '100vh';
              
              // 使用处理后的HTML
              iframe.srcdoc = processedHtml;
              
              // 清空当前元素并插入iframe
              el.innerHTML = '';
              el.appendChild(iframe);
              
              
              // 移除rg-loading类
              el.classList.remove('rg-loading');
            })
            .catch(error => {
              el.classList.remove('rg-loading');
            });
        }
      }




      if (el.classList.contains('rg-hide')) {
        document.querySelectorAll('.merge-product-section').forEach(item => {
          item.classList.add('rg-hide')
        })
        el.classList.remove('rg-hide')
        console.log('over')
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;

      this.addBtn.disabled = !variantAvailable || this.preSelection;

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {

        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.customSetActiveMedia(variantMedia, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');
        const combined = document.getElementById('_combined_listing');
        const price = this.data.formatted[this.variant.id].price_num
        if (combined) {
          const combinedValues = JSON.parse(combined.value || '[]');
          const newPrice = combinedValues.reduce((acc, cur) => Number(cur.value.price) + acc, this.variant.price / 100);
          const newComparePrice = combinedValues.reduce((acc, cur) => Number(cur.value.comparePrice || 0) + acc, (this.variant.compare_at_price || 0) / 100);
          const formatter = new Intl.NumberFormat();
          
          const originalText = priceCurrentEl.textContent;
          const newPriceText = originalText.replace(/[\d,.]+/, formatter.format(newPrice));
          priceCurrentEl.innerHTML = newPriceText

          let newComparePriceText = '';

          if (priceWasEl) {
            if (newComparePrice > newPrice) {
              const originalText = priceWasEl.textContent;
              newComparePriceText = originalText.replace(/[\d,.]+/, formatter.format(newComparePrice));
              priceWasEl.textContent = newComparePriceText;
              priceWasEl.classList.remove('hide')
            } else {
              priceWasEl.classList.add('hide')
            }
          }

          document.querySelectorAll('.reward-rays').forEach((item) => {
            item.textContent = String(parseInt(newPrice) * 10)
          })
          window.updateBottomBarPrice(newPriceText, newComparePriceText);
          window.updatePayPalPrice(parseInt(newPrice));
        } else {
          priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
          if (priceWasEl) {
            priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
          }
          document.querySelectorAll('.reward-rays').forEach((item) => {
            item.textContent = String(parseInt(this.variant.price / 100) * 10);
          })
          window.updateBottomBarPrice(this.data.formatted[this.variant.id].price, this.data.formatted[this.variant.id].compareAtPrice || '')
          window.updatePayPalPrice(Math.floor(price / 100))
        }

        document.dispatchEvent(
          new CustomEvent('product:info', {
            detail: {
              id: this.variant.id,
              price: price,
              compare_at_price: this.variant.compare_at_price,
              option: this.variant.title
            },
            bubbles: true,
          })
        );

        // 判断当前variant是否有税费
        const taxEl = document.querySelector(".taxes_included");
        const noTaxEl = document.querySelector(".taxes_included_no");
        if (this.variant.taxable) {
          if(taxEl) {
            taxEl.classList.remove("hidden");
          }
          if(noTaxEl) {
            noTaxEl.classList.add("hidden");
          }
        }else {
          if(taxEl) {
            taxEl.classList.add("hidden");
          }
          if(noTaxEl) {
            noTaxEl.classList.remove("hidden");
          }
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
